import { useNavigate } from 'react-router-dom'
import { ShieldOff } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { getDashboardPath } from '../services/auth.service'

export default function Unauthorized() {
  const { currentUser } = useAuth()
  const navigate = useNavigate()

  const goBack = () => {
    if (currentUser) {
      navigate(getDashboardPath(currentUser.role), { replace: true })
    } else {
      navigate('/login', { replace: true })
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: '#000000' }}
    >
      <div className="text-center max-w-sm">
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6"
          style={{ background: 'rgba(204,51,0,0.12)', border: '1px solid rgba(204,51,0,0.3)' }}
        >
          <ShieldOff size={28} style={{ color: '#cc3300' }} />
        </div>

        <h1
          className="text-2xl font-bold mb-2"
          style={{ fontFamily: 'Syne, sans-serif', color: '#ffffff' }}
        >
          Access Denied
        </h1>
        <p className="text-sm mb-8" style={{ color: '#a0a0a0', fontFamily: 'DM Sans, sans-serif' }}>
          You don't have access to this area. If you think this is a mistake, contact the system administrator.
        </p>

        <button
          onClick={goBack}
          className="px-6 py-2.5 rounded-lg text-sm font-semibold transition-all"
          style={{
            background: '#ffc600',
            color: '#000000',
            fontFamily: 'DM Sans, sans-serif',
            fontWeight: 600,
          }}
        >
          Back to my dashboard
        </button>
      </div>
    </div>
  )
}
